class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.url = this.querySelector("a").getAttribute("href");
    this.product = this.dataset.product;
    this.dialog = this.querySelector("product-dialog");
    this.actions = this.querySelectorAll("button");
    this.backdrop = document.querySelector("[data-backdrop]");
  }

  connectedCallback() {
    this.url.includes("?")
      ? (this.url = `${this.url}&section_id=product-dialog`)
      : (this.url = `${this.url}?section_id=product-dialog`);
    this.actions.forEach((action) => {
      switch (action.dataset.action) {
        case "open-dialog":
          action.addEventListener("click", this.openDialog.bind(this));
          break;
        case "close-dialog":
          action.addEventListener("click", this.closeDialog.bind(this));
          break;
      }
    });
    this.backdrop.addEventListener("click", this.closeDialog.bind(this));
  }

  openDialog() {
    this.dialog.setAttribute("data-active", "");
    this.actions[0].disabled = true;
    if (!isMobile()) {
      this.backdrop.setAttribute("data-active", "");
    }
    freezeBody(true);
    !this.dialog.querySelector("[data-dynamic-product-dialog-content]") &&
      this.fetchProductDialog();
  }

  closeDialog() {
    this.dialog.removeAttribute("data-active");
    this.actions[0].disabled = false;
    if (!isMobile()) {
      this.backdrop.removeAttribute("data-active");
    }
    freezeBody(false);
  }

  async fetchProductDialog() {
    await fetch(this.url)
      .then((response) => response.text())
      .then((html) => {
        const product_dialog = new DOMParser().parseFromString(
          html,
          "text/html",
        );
        this.dialog.querySelector("[data-product-dialog-content]").outerHTML =
          product_dialog.body.firstChild.firstElementChild.innerHTML;

        // if (!isMobile()) {
        //   this.backdrop.setAttribute("data-active", "");
        // }

        freezeBody(true);
      });
  }
}

customElements.define("product-card", ProductCard);
